import React from 'react';
import Layout from 'shared/components/Layout/Layout';
import ZoomDocumentation from './ZoomDocumentation';
import HeaderWhite from '../../components/HeaderWhite/HeaderWhite';
import BlueNav from '../../components/BlueNav/BlueNav';

function action() {
  return {
    chunks: ['zoom-documentation'],
    title: 'Tutorfly Zoom Integration Documentation',
    component: (
      <Layout>
        <BlueNav menuType="forFamilies" />
        <HeaderWhite
          breadcrumb="Tutoring for Families &gt; Tutorfly Zoom Integration Documentation"
          title="Tutoring for Families"
        />
        <ZoomDocumentation />
      </Layout>
    ),
  };
}

export default action;
